import { RangePickerProps } from 'antd/es/date-picker'
import dayjs, {
  Dayjs,
  isDayjs,
} from 'dayjs'
import { useMemo } from 'react'

import { selectFeatureTimezone } from '@/redux/global-selector'
import { useAppSelector } from '@/redux/utils'


type SinglePickerValue = Dayjs | undefined | null
type RangePickerValue = Parameters<NonNullable<RangePickerProps['onChange']>>[0]

export const useDayjsFromEvent = () => {
  const { featureTimezoneName } = useAppSelector(selectFeatureTimezone)
  return useMemo(() => {
    function getDayjsFromEvent(value: SinglePickerValue): Dayjs
    function getDayjsFromEvent(value: RangePickerValue): [Dayjs, Dayjs]
    function getDayjsFromEvent(value: SinglePickerValue | RangePickerValue) {
      if (!value) {
        return value
      }
      if (isDayjs(value)) {
        return value.tz(featureTimezoneName, true)
      }
      const [start, end] = value
      return [
        (start || dayjs()).tz(featureTimezoneName, true),
        (end || dayjs()).tz(featureTimezoneName, true),
      ]
    }
    return getDayjsFromEvent
  }, [featureTimezoneName])
}

export const useISOString = () => {
  const { featureTimezoneName } = useAppSelector(selectFeatureTimezone)
  return useMemo(() => ({
    getValueFromEvent: (value?: Dayjs | Dayjs[]) => {
      if (!value) {
        return value
      }
      if (isDayjs(value)) {
        return value.tz(featureTimezoneName).toISOString()
      }
      return [
        value[0].tz(featureTimezoneName).toISOString(),
        value[1].tz(featureTimezoneName).toISOString(),
      ]
    },
    getValueProps: (isoString?: string | string[]) => {
      if (typeof isoString === 'string') {
        return { value: isoString ? dayjs(isoString).tz(featureTimezoneName) : undefined }
      }
      return {
        value: isoString ? [
          dayjs(isoString[0]).tz(featureTimezoneName),
          dayjs(isoString[1]).tz(featureTimezoneName),
        ] : undefined,
      }
    },
  }), [featureTimezoneName])
}
